import { apiClient } from "../config";

export const infoCenterApi = {
  // Get all info items by type (vacancy, events, news, others)
  getAllInfoCenter: async (infoType: string) => {
    try {
      const { data } = await apiClient.get(
        `/public/getAllInfoCenter/${infoType}`,
      );
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(`Error fetching ${infoType} info:`, error);
      return [];
    }
  },

  // Get image/picture for an info item
  getInfoCenterFilePics: async (infoCenterFileId: number) => {
    try {
      const response = await apiClient.get(
        `/public/getInfoCenterFilePics/${infoCenterFileId}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching image for item ${infoCenterFileId}:`,
        error,
      );
      throw error;
    }
  },

  // Get full HTML material/content for an info item  ← ADD THIS
  getInfoCenterMaterial: async (infoCenterFileId: number) => {
    try {
      const { data } = await apiClient.get(
        `/public/getInfoCenterMaterial/${infoCenterFileId}`,
      );
      return data as string;
    } catch (error) {
      console.error(
        `Error fetching material for item ${infoCenterFileId}:`,
        error,
      );
      throw error;
    }
  },
};
